'use client';
import { useEffect, useState } from 'react';
import * as Progress from '@radix-ui/react-progress';

import { cn } from '../../../lib';

type ProgressBarProps = {
  currentStep: number;
  totalSteps: number;
  className?: string;
  indicatorClassName?: string;
};

export const ProgressBar = ({
  currentStep,
  totalSteps,
  className,
  indicatorClassName,
}: ProgressBarProps) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (totalSteps !== 0) {
      setProgress((currentStep / totalSteps) * 100);
    }
  }, [currentStep, totalSteps]);
  return (
    <Progress.Root
      className={cn('h-sm overflow-hidden rounded-full bg-teal-200', className)}
      value={progress}
      data-testid="progress-bar-root"
    >
      <Progress.Indicator
        className={cn(
          'h-full bg-tertiary transition-transform duration-700',
          indicatorClassName,
        )}
        style={{ transform: `translateX(-${100 - progress}%)` }}
        data-testid="progress-bar-indicator"
      />
    </Progress.Root>
  );
};
